const API_BASE = process.env.REACT_APP_API_BASE;

export async function requestAccount(formData) {
  const r = await fetch(`${API_BASE}/api/request-account`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(formData),
  });
  const data = await r.json();
  if (!r.ok) throw new Error(data.error || "Request failed");
  return data;
}
